import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {UpdateActiveStep, UpdateOpenStepsList} from "../../../../redux/actions/tourActions";
import {STEPS} from "../../helpers";
import {Tour} from "antd";
import {useTourActions} from "../../hooks";
import AiAgentsForWork from "../AIAgentsForWork/AIAgentsForWork";
import {TRIGGER_TYPE} from "../../../../pages/AiAgentsPage/helpers";
import './TourSixStep.scss';

const TourSixStep = ({openTemplateModal}) => {
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.tour?.activeStep);
    const templatesList = useSelector(state => state.agents.templatesList || []);
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [step, setStep] = useState(0);
    const findProcesedTemplate = templatesList.find((item) => item.trigger_type === TRIGGER_TYPE.ON_VIDEO_PROCESS);
    const findScheduleTemplate = templatesList.find((item) => item.trigger_type === TRIGGER_TYPE.ON_SCHEDULE);
    const {handleClickNextStep6} = useTourActions();

    useEffect(() => {
        if ([STEPS.SIX].includes(activeStep)) {
            setTimeout(() => {
                setIsOpen(true)
            }, 500)
        } else {
            setIsOpen(false)
        }
    }, [activeStep])
    let cachedElement = null;

    const steps = [
        {
            title: t('tour_step_6'),
            description: <AiAgentsForWork/>,
            target: () => document.querySelector(`.ai-agents__block`),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => {
                    setStep(1);
                }
            },
            placement: 'bottom'
        },
        {
            title: t('tour_step_6_1'),
            description: t('tour_step_6_1_desc'),
            target: () => document.getElementById(`template-id-${findProcesedTemplate?.id}`),
            nextButtonProps: {
                children: (
                    <div className="button-next">
                        <div className="button-next--later" onClick={() => setStep(2)}>{t('later')}</div>
                        <span className="button-next--next" onClick={(e) => {
                            setStep(3)
                            openTemplateModal(findProcesedTemplate?.id)
                        }}
                        >
                                                       {t('try_it')}
                        </span>
                    </div>
                ),
            },
            placement: 'bottom'
        },
        {
            title: t('tour_step_6_2'),
            description: t('tour_step_6_2_desc'),
            target: () => document.getElementById(`template-id-${findScheduleTemplate?.id}`),
            nextButtonProps: {
                children: (
                    <div className="button-next">
                        <div className="button-next--later" onClick={() => setStep(3)}>{t('later')}</div>
                        <span className="button-next--next" onClick={(e) => {
                            setStep(3)
                            openTemplateModal(findScheduleTemplate?.id)
                        }}
                        >
                            {t('try_it')}
                        </span>
                    </div>
                ),
            },
            placement: 'bottom'
        },
        {
            title: t('tour_step_6_3'),
            description: t('tour_step_6_3_desc'),
            target: () => document.querySelector('.template-list'),
            nextButtonProps: {
                children: <span>{t('next')}</span>,
                onClick: () => {
                    handleClickNextStep6();
                    setStep(0);
                    setIsOpen(false);
                    dispatch(UpdateOpenStepsList(true))
                }
            },
            placement: 'bottom'
        },
    ];

    return (
        <Tour
            rootClassName={`${(step === 1 || step === 2) ? 'tour-six' : ''}`}
            indicatorsRender={(current, total) => (
                <span>
                      {current + 1} / {total}
                     </span>
            )}
            placement="left"
            open={isOpen}
            current={step}
            onClose={() => {
                dispatch(UpdateActiveStep(null));
                setIsOpen(false)
                setStep(0)
            }}
            steps={steps}
            gap={{radius: 12, offset: 4 }}
        />
    );
};

export default TourSixStep;